<template>
  <v-card>
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      v-bind:class = "{noo : home}"
      :headers="headers"
      :items="desserts"
      :search="search"
      :custom-sort= customSort
      sort-by="LoanRange"
      must-sort
      mobile-breakpoint="450"
    ></v-data-table>
  </v-card>
</template>

<style>
.noo .v-data-footer__select{
  display: none;
  visibility: hidden;
}

@media only screen and (max-width: 900px){
  /* width */
  ::-webkit-scrollbar {
    width: 3px;
  }
  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #45506e; 
  }
  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #62739c; 
  }
}
@media only screen and (max-width: 450px){h1{font-size: 20px;}}

</style>

<script>
  export default {
    data () {
      return {
        search: '',
        home: false,
        headers: [
          {
            text: 'Name',
            align: 'start',
            value: 'BusinessName',
          },
          { text: 'Loan Amount', value: 'LoanRange' },
          { text: 'Business Type', value: 'BusinessType' },
          { text: 'Jobs Retained', value: 'JobsRetained' },
        ],
        desserts: 
        [
  {
    "LoanRange": "$5-10 million",
    "BusinessName": "AMERICAN EAGLE LIFECARE CORPORATION",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 500
  },
  {
    "LoanRange": "$5-10 million",
    "BusinessName": "CAYMAN CHEMICAL COMPANY INC",
    "BusinessType": "Corporation",
    "JobsRetained": 352
  },
  {
    "LoanRange": "$5-10 million",
    "BusinessName": "ERVIN INDUSTRIES, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 54
  },
  {
    "LoanRange": "$5-10 million",
    "BusinessName": "MCKINLEY COMPANIES, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 427
  },
  {
    "LoanRange": "$2-5 million",
    "BusinessName": "ALTARUM INSTITUTE",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 235
  },
  {
    "LoanRange": "$2-5 million",
    "BusinessName": "ARBOR CONSTRUCTION PERSONNEL INC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 118
  },
  {
    "LoanRange": "$2-5 million",
    "BusinessName": "EAST WEST INDUSTRIAL ENGINEERING CO.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": ""
  },
  {
    "LoanRange": "$2-5 million",
    "BusinessName": "EVERSIGHT",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 151
  },
  {
    "LoanRange": "$2-5 million",
    "BusinessName": "GLOBAL EDUCATIONAL EXCELLENCE, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 242
  },
  {
    "LoanRange": "$2-5 million",
    "BusinessName": "GOLD STAR MORTGAGE FINANCIAL GROUP, CORPORATION",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 356
  },
  {
    "LoanRange": "$2-5 million",
    "BusinessName": "MANPOWER, INC. OF SOUTHEASTERN MICHIGAN",
    "BusinessType": "Corporation",
    "JobsRetained": 415
  },
  {
    "LoanRange": "$2-5 million",
    "BusinessName": "ORGAN PROCUREMENT AGENCY OF MICHIGAN",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 235
  },
  {
    "LoanRange": "$2-5 million",
    "BusinessName": "PLANNED PARENTHOOD OF MICHIGAN",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 201
  },
  {
    "LoanRange": "$2-5 million",
    "BusinessName": "REGIS CONSTRUCTION, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$2-5 million",
    "BusinessName": "TEK WISSEN LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": ""
  },
  {
    "LoanRange": "$2-5 million",
    "BusinessName": "VARSITY FORD",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 168
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "A-1 SCREENPRINTING LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 234
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "A2 HOSTING INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 100
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "A2 MEDIA CORP.",
    "BusinessType": "Corporation",
    "JobsRetained": 71
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "ADMINISTRATIVE CONTROLS MGMT INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 68
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "ADVANTAGE COMPUTING SYSTEMS, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 80
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "ARBOR RESEARCH COLLABORATIVE FOR HEALTH",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 106
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "B/D OPS, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 124
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "BOONE AND DARR, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 72
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "CAREEVOLUTION",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "CONLIN TRAVEL, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 64
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "DAYSMART SOFTWARE, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 97
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "DIVERSIFIED COMPUTER SUPPLIES, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 98
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "DOUGLAS N. HIGGINS INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 68
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "DUNNING MOTORS INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 146
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "FREIGHTVERIFY INC",
    "BusinessType": "Corporation",
    "JobsRetained": 59
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "GENERAL SCIENTIFIC CORPORATION",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 75
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "GREENHILLS SCHOOL",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 102
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "GRETCHEN'S HOUSE INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 260
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "HIPR PACSOFT TECHNOLOGIES, INC",
    "BusinessType": "Corporation",
    "JobsRetained": 114
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "HOBBS + BLACK ASSOCIATES, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 65
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "HOME APPLIANCE MART INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 109
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "HOOK STUDIOS LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 117
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "INI GROUP, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 170
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "JOAK AMERICAN HOMES",
    "BusinessType": "Professional Association",
    "JobsRetained": 180
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "JOHN DARR MECHANICAL, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 46
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "LIBERTY TITLE AGENCY INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 150
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "MAY MOBILITY, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 58
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "MICRO-TECH ENDOSCOPY USA INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 59
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "NUSTEP, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 102
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "OXFORD PROPERTY MANAGEMENT LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 76
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "R.N.A. OF ANN ARBOR, INCORPORATED",
    "BusinessType": "Corporation",
    "JobsRetained": ""
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "RAVE ASSOCIATES, INC",
    "BusinessType": "Corporation",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "REBO LIGHTING & ELECTRONICS, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 114
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "SKYSYNC, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 56
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "SOURCEPRO INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 147
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "SUBURBAN ANN ARBOR, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 128
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "THE TRENTON CORPORATION",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 64
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "WEBER'S INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 211
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "XORAN TECHNOLOGIES LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 64
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "ZINGERMAN'S BAKEHOUSE, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 160
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "ZINGERMAN'S DELICATESSEN, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 201
  },
  {
    "LoanRange": "$1-2 million",
    "BusinessName": "ZOLLER INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 106
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "ABOVE THE TREELINE, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 27
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "ADAPTIVE ENERGY, LLC.",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 13
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "ADULT LEARNING SYSTEMS LOWER MICHIGAN INC",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 175
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "AFIA, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 21
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "ALL STAR DRIVER EDUCATION, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 75
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "AMERINET OF MICHIGAN, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 15
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "ANN ARBOR ANIMAL HOSPITAL, PC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 56
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "ANN ARBOR FIRE PROTECTION",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "ANN ARBOR HANDS-ON MUSEUM",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 72
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "ANN ARBOR YOUNG MEN'S CHRISTIAN ASSOCIATION",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 268
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "ANU SOFTWARE CONSULTANTS, INC",
    "BusinessType": "Corporation",
    "JobsRetained": 7
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "APPLIED DYNAMICS INTERNATIONAL, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 37
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "ARBOR FARMS, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "AUTOMOTIVE DEALER MANAGEMENT, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 28
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "AVALON NONPROFIT HOUSING CORPORATION",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 87
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "BECKETT & RAEDER, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 26
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "BEL ENVIRONMENTAL ENGINEERING, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 37
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "BIOVIGIL HYGIENE TECHNOLOGIES, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 24
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "BLUE LLAMA ENTERPRISES, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 25
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "BLUE NEWT SOFTWARE TECHNOLOGIES, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 21
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "CAELYNX LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 21
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "CAMPFIRE INTERACTIVE",
    "BusinessType": "Corporation",
    "JobsRetained": 25
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "CARLISLE WORTMAN ASSOCIATES, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 35
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "CARRYOUT STORES INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 151
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "CASCABEL VENTURES LLC",
    "BusinessType": "Corporation",
    "JobsRetained": 122
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "CATHOLIC SOCIAL SERVICES OF WASHTENAW COUNTY",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 113
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "CATYLIST REAL ESTATE SOFTWARE, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 63
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "CENTER FOR AUTOMOTIVE RESEARCH",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 26
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "CFI GROUP USA, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 35
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "COHERIX, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 36
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "CONLIN, MCKENNEY & PHILBRICK, P.C.",
    "BusinessType": "Corporation",
    "JobsRetained": 40
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "CONTROL GAGING, INC",
    "BusinessType": "Corporation",
    "JobsRetained": 34
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "CRISCUOLO & WOODS LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 79
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "CUSHING-MALLOY, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 30
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "CYBERNET SYSTEMS CORP.",
    "BusinessType": "Corporation",
    "JobsRetained": 35
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "DATASTAT, INC",
    "BusinessType": "Corporation",
    "JobsRetained": 39
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "DOCNETWORK, INC",
    "BusinessType": "Corporation",
    "JobsRetained": 43
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "DOMINO'S FARMS CORPORATION",
    "BusinessType": "Corporation",
    "JobsRetained": 116
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "DYNICS INC",
    "BusinessType": "Corporation",
    "JobsRetained": 71
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "ENMARK SYSTEMS, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 37
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "ENMET, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 35
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "ENSPIRE DENTAL",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": ""
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "EXCEPTIONAL HOME CARE, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 61
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "FAIR FOOD NETWORK",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 34
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "FATHER GABRIEL RICHARD HIGH SCHOOL",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 66
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "FIRST MARTIN CORPORATION",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 22
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "FRANWORTH LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 27
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "GDI INFOTECH INC",
    "BusinessType": "Corporation",
    "JobsRetained": 31
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "GERMAIN ON STATE I, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 78
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "GERMAIN ON STATE II, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 84
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "GFG INSTRUMENTATION, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 27
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "GRAHAM HOTEL SYSTEMS, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 114
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "H3D, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 10
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "HABITAT FOR HUMANITY OF HURON VALLEY",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 37
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "HILLSIDE TERRACE HOLDINGS LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 72
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "HINES INDUSTRIES, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 40
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "HOME OF NEW VISION",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 85
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "HONEY CREEK COMMUNITY SCHOOL ACADEMY",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 51
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "HOOPER HATHAWAY, P. C.",
    "BusinessType": "Corporation",
    "JobsRetained": 21
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "HUDSON A PROFESSIONAL CORPORATION",
    "BusinessType": "Corporation",
    "JobsRetained": 79
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "HUMAN ELEMENT INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 39
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "HUMANE SOCIETY OF HURON VALLEY",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 149
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "IMBIBE LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 57
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "INNS OF SANIBEL, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 72
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "INTEGRATED DESIGN, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 40
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "INTEGRATED MANAGEMENT SYSTEMS, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 43
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "JEWISH FAMILY SERVICES OF WASHTENAW COUNTY, INC.",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 56
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "KENNEDY CARE ANN ARBOR, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 191
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "KENNEDY, MARZONIE, GRAY, AND ASSOCIATES PLLC",
    "BusinessType": "Limited Liability Partnership",
    "JobsRetained": 45
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "KNIGHT'S BAR RESTAURANT, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 77
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "KNIGHT'S LIBERTY MAYNARD",
    "BusinessType": "Corporation",
    "JobsRetained": 70
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "KOCH & WHITE HEATING & COOLING, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 47
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "KUMANU, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 27
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "LAFONTAINE BUICK GMC OF ANN ARBOR INC",
    "BusinessType": "Corporation",
    "JobsRetained": 58
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "LAURA K GANGER MD PC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 44
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "LCOF ANN ARBOR OPERATING LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 55
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "LEELANAU WINE CELLARS, LTD.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 71
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "LEGATUS INC",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 24
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "LEON HAND-CRAFTED SPEAKERS, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 68
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "LEWIS BROS., INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 23
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "LIBERTY ATHLETIC CLUB INC",
    "BusinessType": "Corporation",
    "JobsRetained": 155
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "LILAX TECHNOLOGIES INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 36
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "LOGIC SOLUTIONS INC",
    "BusinessType": "",
    "JobsRetained": 28
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "LTI INFORMATION TECHNOLOGY, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 35
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "LYCERA CORP.",
    "BusinessType": "Corporation",
    "JobsRetained": 19
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "M-DEN, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 188
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "MCCREADIE GROUP, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 18
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "MEADOWLARK BUILDERS LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 54
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "MENLO INNOVATIONS LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 43
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "METRO DELIVERY INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "MICHIGAN DISTRICT OF THE LUTHERAN CHURCH-MISSOURI SYNOD, INC.",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 33
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "MICHIGAN HEADACHE & NEUROLOGICAL INSTITUTE, PC",
    "BusinessType": "Corporation",
    "JobsRetained": 41
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "MICHIGAN THEATER FOUNDATION",
    "BusinessType": "Professional Association",
    "JobsRetained": 100
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "MIDWESTERN CONSULTING LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 50
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "MIDWESTERN SOFTWARE SOLUTIONS, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 27
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "MOELLER PC",
    "BusinessType": "Corporation",
    "JobsRetained": 30
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "MOTAWI TILEWORKS INC",
    "BusinessType": "Corporation",
    "JobsRetained": 43
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "MSVRG DOWNTOWN VENTURES, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 58
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "NATIONAL KIDNEY FOUNDATION OF MICHIGAN",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 66
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "NEURONEXUS TECHNOLOGIES, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 31
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "NEW EAGLE CONSULTING, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 26
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "NICKGRACE, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "NOMAD TOWER SERVICES, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 42
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "O'NEAL CONSTRUCTION OF MICHIGAN, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 37
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "OBERON TECHNOLOGIES INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 37
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "OPENBOX SOLUTIONS, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 35
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "OPTIFLOW, INC",
    "BusinessType": "Corporation",
    "JobsRetained": 49
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "PACIFIC INDUSTRIAL DEVELOPMENT CORP.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "PACKARD HEALTH, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 76
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "PARTNERS IN INTERNAL MEDICINE, PLLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 42
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "PICASSO CAFE, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 26
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "PIES INC",
    "BusinessType": "Corporation",
    "JobsRetained": 155
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "PINNACLE EXPRESS, INC",
    "BusinessType": "Corporation",
    "JobsRetained": 46
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "PIZZA HOUSE ANN ARBOR INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 90
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "POLOFIELDS ENTERPRISES LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": ""
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "PRINT-TECH, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 26
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "PYRAMID CONSULTING INTERNATIONAL, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 35
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "QUALITY AIRE SYSTEMS, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 49
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "RE GROUP, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 25
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "RECYCLE ANN ARBOR",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "RESOURCE RECYCLING SYSTEMS, INCORPORATED",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 47
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "RETIREMENT SOLUTIONS, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 30
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "RIDECORP, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 78
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "ROBERT KENNEDY",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 61
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "ROSEDALE PRODUCTS, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 87
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "SAINT FRANCIS OF ASSIS PARISH ANN ARBOR",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 88
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "SERENITY3 HOME HEALTH INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 150
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "SESI MOTORS, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 62
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "SHAR PRODUCTS COMPANY",
    "BusinessType": "Corporation",
    "JobsRetained": 93
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "SPECTRUM THERAPY CENTER, INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 64
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "SPIRITUS SANCTUS ACADEMY",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 55
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "SPOT DESIGN LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 53
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "SRA2 LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "ST. PAUL EVANGELICAL LUTHERAN CHURCH",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 72
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "SUBURBAN ANN ARBOR 2, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 54
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "SUBURBAN ANN ARBOR 4, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 46
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "SUBURBAN ANN ARBOR 5, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 42
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "SWIFT BIOSCIENCES, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 38
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "SYNERGY SOFTWARE & CONSULTING LLC",
    "BusinessType": "Corporation",
    "JobsRetained": 43
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "TDLS &AMP; ASSOCIATES LLCDBA VISITING ANGEL S OF WASHTENAW COUNTY",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 25
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "THALNER ELECTRONICS LABORATORIES",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": ""
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "THE ANN ARBOR T-SHIRT COMPANY, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 76
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "THE MUSLIM COMMUNITY ASSOCIATION OF ANN ARBOR AND VICINITY",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 63
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "THE NORFOLK GROUP, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 24
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "THE RUDOLF STEINER SCHOOL ASSOCIATION OF ANN ARBOR",
    "BusinessType": "Corporation",
    "JobsRetained": 105
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "THE SOLUTIONS GROUP, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 20
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "THE UNIVERSITY MUSICAL SOCIETY",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 29
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "TLS PRODUCTIONS, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 26
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "TRIFECTA PRODUCTIONS, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": ""
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "UNIVERSITY LITHOPRINTERS, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 50
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "VANSTON-O'BRIEN, INC",
    "BusinessType": "Corporation",
    "JobsRetained": 39
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "WICKFIELD PROPERTIES, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 57
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "WISELY INC",
    "BusinessType": "Corporation",
    "JobsRetained": 30
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "WOLVERINE STEEL ERECTORS INC",
    "BusinessType": "Corporation",
    "JobsRetained": 56
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "WOLVERINE TECHNICAL STAFFING, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 31
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "WR SPECIALISTS, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 29
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "ZINGERMAN'S ROADHOUSE, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 143
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "ZINGERMAN'S SERVICE NETWORK, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 53
  },
  {
    "LoanRange": "$350,000-1 million",
    "BusinessName": "ZOMEDICA PHARMACEUTICALS INC",
    "BusinessType": "Corporation",
    "JobsRetained": 20
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "116 - 120 W HURON, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 50
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "3685 JACKSON ROAD, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 53
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "A & N ELECTRIC INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": ""
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "A.M. SERVICES INC",
    "BusinessType": "Corporation",
    "JobsRetained": 28
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ABA INSIGHT LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 41
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ABC DENTAL P.C.",
    "BusinessType": "Corporation",
    "JobsRetained": 22
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ABSOLUTE MEDICAL IMAGING INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": ""
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ABSOLUTE TITLE, INC",
    "BusinessType": "Corporation",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ACE BARNES HARDWARE INC",
    "BusinessType": "Corporation",
    "JobsRetained": 50
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ADADAPTED, INC",
    "BusinessType": "Corporation",
    "JobsRetained": 24
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "AERODYNAMIC ADVISORY LLC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 6
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "AFTERNOON DELIGHT INC",
    "BusinessType": "Corporation",
    "JobsRetained": 24
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "AGRISIGHT INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "AL WALK PLUMBING INC",
    "BusinessType": "Corporation",
    "JobsRetained": 6
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ALLEN W. SEEL, D.D.S., P.C",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 24
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ALLIED, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 20
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ALMA MACHINERY CO., INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 22
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ALPHA CONTRACTING, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 19
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ALTECH MECHANICAL SERVICE LLC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 11
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ALTRUIC ADVISORS, PLLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 6
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "AMERICAN CUSTOMER SATISFACTION INDEX LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 31
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "AMERICAN TITLE COMPANY OF WASHTENAW",
    "BusinessType": "Corporation",
    "JobsRetained": 14
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ANC TRUCKING, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 27
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ANDERSON PAINT COMPANY",
    "BusinessType": "Corporation",
    "JobsRetained": 15
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ANN ARBOR ANIMAL HOSPITAL EMERGENCY, P.C.",
    "BusinessType": "Corporation",
    "JobsRetained": 20
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ANN ARBOR ARCHITECTS COLLABORATIVE, INC",
    "BusinessType": "Corporation",
    "JobsRetained": 13
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ANN ARBOR ARMS, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 22
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ANN ARBOR BIVOUAC INC",
    "BusinessType": "Corporation",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ANN ARBOR CENTER FOR INDEPENDENT LIVING, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 24
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ANN ARBOR INN & SUITES, INC",
    "BusinessType": "Corporation",
    "JobsRetained": 28
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ANN ARBOR OBSERVER COMPANY",
    "BusinessType": "Corporation",
    "JobsRetained": 17
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ANN ARBOR PEDIATRIC DENTISTRY, PLLC",
    "BusinessType": "Professional Association",
    "JobsRetained": 26
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ANN ARBOR PHARMACOMETRICS GROUP INC",
    "BusinessType": "Corporation",
    "JobsRetained": 14
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ANN ARBOR RENT ALL LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 25
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ANN ARBOR SWIM SCHOOL LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 74
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ANN ARBOR SYMPHONY ORCHESTRA, INC.",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 255
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ANNA'S HOUSE ANN ARBOR LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 30
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "APPLE DOUGH, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 134
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "APPLE PLAYSCHOOLS",
    "BusinessType": "Professional Association",
    "JobsRetained": 40
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ARBOR ASSAYS INC",
    "BusinessType": "Corporation",
    "JobsRetained": 15
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ARBOR BEVERAGE COMPANY",
    "BusinessType": "Corporation",
    "JobsRetained": 19
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ARBORMOON SOFTWARE INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 7
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ARBORTRUST WEALTH ADVISORS, LLC",
    "BusinessType": "Partnership",
    "JobsRetained": 9
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ARCADE TRAVEL, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 21
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ASSOCIATION MANAGEMENT GROUP LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": ""
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ATTAC CONSULTING GROUP, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 13
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "AVE MARIA COMMUNICATIONS",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 15
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "AXEL PRODUCTS INC",
    "BusinessType": "Corporation",
    "JobsRetained": 11
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "AYSLING LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 19
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "B'NAI B'RITH HILLEL FOUNDATIONS, INC.",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 41
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "BCN ASO, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 17
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "BELL TOWER/CAMPUS INN LIMITED PARTNERSHIP",
    "BusinessType": "Partnership",
    "JobsRetained": 51
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "BIA CLINICAL GROUP LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 10
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "BIGGER THAN TEN, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "BIO ENERGY MEDICAL CENTER, P.C.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 16
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "BLUE ROOF HOSPITALITY INC",
    "BusinessType": "Corporation",
    "JobsRetained": 45
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "BLUMIRA, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 13
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "BRAVESOFTTECH, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 16
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "BREWER'S INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 22
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "BROOKHAVEN MANOR LIMITED PARTNERSHIP",
    "BusinessType": "Partnership",
    "JobsRetained": 32
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "BROWN & DELINE WEST, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 42
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "C.W.W., INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 18
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "CABRIO TNM HOLDINGS LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 16
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "CARE TRANSPORT INC",
    "BusinessType": "Corporation",
    "JobsRetained": 61
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "CARSON'S OF ANN ARBOR, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 39
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "CBM LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 16
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "CHILD CARE NETWORK WASHTENAW 4C",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 23
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "CHRISTIAN SCHOOL ASSOCIATION OF ANN ARBOR",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 38
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "CIMDATA INC",
    "BusinessType": "Corporation",
    "JobsRetained": 15
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "CITY LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 48
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "CLIFF KEEN WRESTLING PRODUCTS, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 24
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "CLONLARA, INC & JAMES & PATRIC",
    "BusinessType": "Sole Proprietorship",
    "JobsRetained": 23
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "COMMUNITY DAYCARE AND PRESCHOOL",
    "BusinessType": "Non-Profit Childcare Center",
    "JobsRetained": 73
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "COMPASSIONATE CARE ANIMAL HOSPITAL PLLC",
    "BusinessType": "Corporation",
    "JobsRetained": 26
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "CONTEK, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 11
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "COPYTWO INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 20
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "CORPORATION FOR A SKILLED WORKFORCE",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 15
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "COTTAGE INN CARRY OUT AND DELIVERY, INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 19
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "COTTAGE INN DISTRIBUTION, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 24
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "COTTAGE INN INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 49
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "COY ENTERPRISES, INC",
    "BusinessType": "Corporation",
    "JobsRetained": 49
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "CPG MANAGEMENT, INC",
    "BusinessType": "Corporation",
    "JobsRetained": 37
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "CREATEMYTEE LLC",
    "BusinessType": "Corporation",
    "JobsRetained": 28
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "CREATING BRIGHTER FUTURES, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 38
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "CYBERCRIME SUPPORT NETWORK",
    "BusinessType": "Corporation",
    "JobsRetained": 24
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "DAHLMANN APARTMENTS LTD.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 14
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "DALDIN VETERINARY SERVICES, P.C.",
    "BusinessType": "Corporation",
    "JobsRetained": 22
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "DANMAR PRODUCTS INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 34
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "DAYCROFT",
    "BusinessType": "Professional Association",
    "JobsRetained": 30
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "DEBS INFONET, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 21
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "DENISON CONSULTING, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 26
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "DENTISTRY AS FINE ART, PLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 9
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "DIEM DIRECT LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 8
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "DONALD WURTZEL DDS PC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 23
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "DYNAMO METRICS INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 9
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "EARLE'S GARAGE, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 31
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "EASTHAVEN VETERINARY CLINIC, PLC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 27
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ECOLOGY CENTER, INC.",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 27
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "EDB ENTERPRISES, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 36
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ELATI HOTEL LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 17
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ELIZABETH BARBER DDS MS P C",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 14
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ELLE'S ENTERPRISES, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 35
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "EMERGENCY VETERINARY HOSPITAL, PLLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 31
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "EMMAUS HEALTH PARTNERS",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 18
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ENDRA LIFE SCIENCES INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 14
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ENITIA CORP",
    "BusinessType": "Corporation",
    "JobsRetained": 16
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ESQUIRE INTERIORS INC",
    "BusinessType": "Corporation",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "EXCHANGE CAPITAL MANAGEMENT, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 11
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "EXECUTIVE HOSPITALITY, INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": ""
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "EZ DENTAL PC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 10
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "FERGUSON WIDMAYER PC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 13
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "FINN'S J M & J INSURANCE AGENCY, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "FIRST UNITED METHODIST CHURCH OF ANN ARBOR",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 24
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "FLEETILLA, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 13
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "FLEXSYS INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 11
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "FOREVER LABS, INC.",
    "BusinessType": "",
    "JobsRetained": 12
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "FOSTERING FUTURES",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": ""
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "FOUNDATION PRESCHOOL OF WASHTENAW COUNTY",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 34
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "FREE RIDE POWER SPORTS, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 15
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "FRISBIE MOVING AND STORAGE",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 38
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "FRITA ANN ARBOR, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "GAELIC CONCEPTS, L.L.C.",
    "BusinessType": "Corporation",
    "JobsRetained": 35
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "GALAXY BRAIN AND THERAPY CENTER, A DBA FOR LIFE SKILLS COMMUNITY REHABILITATION,",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 11
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "GENOMENON, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 17
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "GEONEXUS TECHNOLOGIES L.L.C.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 19
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "GERALD ALCOCK COMPANY LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": ""
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "GERBER INVESTMENT COMPANY, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 13
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "GERMAIN ON JACKSON, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 35
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "GERMAN MACHINE TOOLS OF AMERICA",
    "BusinessType": "Corporation",
    "JobsRetained": 8
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "GOOD SPORTS LIMITED PARTNERSHIP",
    "BusinessType": "Partnership",
    "JobsRetained": 27
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "GRACE ANN ARBOR CHURCH",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 18
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "GRAPA, L.L.C",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 38
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "GRATZI RESTAURANT IN MIDLAND, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 39
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "GUARDIAN TREE EXPERTS, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 26
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "GUENTHER BUILDING CO.",
    "BusinessType": "Corporation",
    "JobsRetained": 10
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "GYM AMERICA INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 48
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "HANDS ACROSS THE WATER, INC.",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 41
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "HARPER ELECTRIC INC",
    "BusinessType": "Corporation",
    "JobsRetained": 21
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "HEBREW DAY SCHOOL OF ANN ARBOR",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 22
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "HENSON NOVELTIES INC",
    "BusinessType": "Corporation",
    "JobsRetained": 41
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "HOME CARE EXCELLENCE, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": ""
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "HOMES BREWERY, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "HOUSEKEEPING ASSOCIATES, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 65
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "HURON LAWN SERVICE INC",
    "BusinessType": "Corporation",
    "JobsRetained": 28
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "HURON RIVER WATERSHED COUNCIL",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 13
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "HUTZEL PLUMBING & HEATING CO",
    "BusinessType": "Corporation",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ICHIBAN JAPANESE STEAK HOUSE &AMP; SUSHI BAR LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 20
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "IMAGEMASTER PRINTING LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 23
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "INDUSTRYSTAR SOLUTIONS LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 10
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "INTER-COOPERATIVE COUNCIL AT THE UNIVERSITY OF MICHIGAN",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ISCIENCES, L.L.C",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 13
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "JERUSALEM GARDEN INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 32
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "JEWISH COMMUNITY CENTER OF GREATER ANN ARBOR",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 50
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "JNS FACILITY MAINTENANCE LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 40
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "JODON ENGINEERING ASSOCIATES INC",
    "BusinessType": "Corporation",
    "JobsRetained": 15
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "JP SALES COMPANY LLC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 10
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "KATHERINE'S CATERING AND SPECIAL EVENTS INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 99
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "KEN COOK'S PLUMBING AND HEATING, INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 23
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "KNOX PRESBYTERIAN CHURCH OF ANN ARBOR",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 20
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "KRULL CONSTRUCTION CO., INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 16
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "LAFAYETTE CONSOLIDATED",
    "BusinessType": "Partnership",
    "JobsRetained": 55
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "LAFONTAINE IMPORTS OF ANN ARBOR INC",
    "BusinessType": "Corporation",
    "JobsRetained": 34
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "LAMBERT INDUSTRIES, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 15
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "LAST WORD ANN ARBOR, LLC",
    "BusinessType": "Corporation",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "LEISURE WORKS LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 11
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "LIBERTY PEDIATRICS, P.L.L.C.",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 23
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "LINGUA SCIENCE CORP",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 27
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "LOGEMAN, IAFRATE & LOGEMAN, P.C.",
    "BusinessType": "Corporation",
    "JobsRetained": ""
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "LOY HARTLEY &AMP; CO PC",
    "BusinessType": "Corporation",
    "JobsRetained": 11
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "MAINSTREET VENTURES RESTAURANT GROUP",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 19
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "MANAGEMENT RECRUITERS OF ANN ARBOR, INC. DBA VARIANT PARTNERS",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 17
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "MARTIN REFRIGERATION AND HEATING INC",
    "BusinessType": "Corporation",
    "JobsRetained": 13
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "MAST SHOES, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 16
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "MEDITERRANO, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "METZGERS GERMAN RESTAURANT, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 52
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "MICHIGAN ABILITY PARTNERS",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 42
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "MICHIGAN IMPLANTS &AMP; PERIODONTICS INSTITUTE, PLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "MICHIGAN LEAGUE OF CONSERVATION VOTERS EDUCATION FUND",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 24
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "MICHIGAN ORAL &AMP; MAXILLOFACIAL SURGEONS, P.C.",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "MICHIGAN POWER RODDING, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "MICHWAYNE LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "MID-TECH, INC",
    "BusinessType": "Corporation",
    "JobsRetained": 13
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "MORLOGIC INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 17
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "MOVELLUS CIRCUITS, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 10
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "MS BIOWORKS LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 4
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "NACHTLAW P.C.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 15
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "NATALIE E HENKE DDS PLLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 13
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "NEIGHBORHOOD INSULATION CO INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 11
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "NETWORKS GROUP, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 14
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "NEUTRAL ZONE",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 28
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "NEW FOUNDRY LABS, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 12
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "NEXTTRAVEL, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 15
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "NICHOLS, SACKS, SLANK, SENDELBACH, BUITEWEG & SOLOMON, PC",
    "BusinessType": "Corporation",
    "JobsRetained": 12
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "NICHOLSON HILL GROUP, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 32
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "NO ONES RIVAL",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "NONPROFIT ENTERPRISES AT WORK, INC",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 16
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "NORTH STAR REACH",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 15
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "NOVODYNAMICS INC",
    "BusinessType": "Corporation",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "O-X STUDIO, INC",
    "BusinessType": "Corporation",
    "JobsRetained": 15
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "OAKLAND FAMILY RESTAURANTS INC",
    "BusinessType": "Corporation",
    "JobsRetained": 76
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "OCEAN ORGANICS CORPORATION",
    "BusinessType": "Corporation",
    "JobsRetained": 20
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "OG TECHNOLOGIES, INC",
    "BusinessType": "Corporation",
    "JobsRetained": 11
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "OMICRON INC",
    "BusinessType": "Corporation",
    "JobsRetained": 9
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "OMNEX ENGINEERING AND MANAGEMENT INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 20
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "OMNEX SYSTEMS LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 8
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "OXFORD DESIGN BUILD, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 23
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "PALM PALACE PITTSFIELD LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 45
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "PARAGON SIGHT & SOUND INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 16
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "PEAR SPERLING EGGAN AND DANIELS, P.C.",
    "BusinessType": "Corporation",
    "JobsRetained": 20
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "PEG HOPKINS INC",
    "BusinessType": "Corporation",
    "JobsRetained": 16
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "PENSMORE REINFORCEMENT TECHNOLOGIES, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 25
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "PEOPLE'S FOOD COOPERATIVE",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 50
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "PERICH + PARTNERS, LTD",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 16
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "PHARMACEUTICAL CARE SOLUTIONS, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 18
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "PHIRE ADVERTISING AND DESIGN LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 19
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "PREFERRED TITLE AGENCY OF ANN ARBOR, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 15
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "PROMANAS INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 17
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "QUAD CITY INNOVATIONS, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 13
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "QUALITY FILTERS INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 17
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "R2 SPACE INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 27
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "RENEWAL MINISTRIES, INC",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 26
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "RHOADES & FRANTZ APPLIED SAFETY AND ERGONOMICS, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 20
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "RICHARD BROTHERS PAINTING CONTRACTORS INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 16
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "RIGHTBRAIN NETWORKS, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 14
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "RIPPLE SCIENCE CORP",
    "BusinessType": "Corporation",
    "JobsRetained": 16
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ROBERTSON-MORRISON INC",
    "BusinessType": "Corporation",
    "JobsRetained": 30
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ROOSROAST COFFEE CORPORATION",
    "BusinessType": "Corporation",
    "JobsRetained": 30
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ROSS BEAKES COLLISION SERVICES INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 16
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "RSC OF ANN ARBOR, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 54
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "RUSSELL VIDEO SERVICES, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 16
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "RXA, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 20
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "S & R INC",
    "BusinessType": "Corporation",
    "JobsRetained": 65
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "S-3 ENGINEERING, INC",
    "BusinessType": "Corporation",
    "JobsRetained": 12
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "SAGAN WORKS INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 11
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "SAKSTRUP TOWING, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 15
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "SALAMEN & WORTHING ENTERPRISES LLC",
    "BusinessType": "Corporation",
    "JobsRetained": 16
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "SBD NORTH AMERICA, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 16
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "SCHNORR CORPORATION",
    "BusinessType": "Corporation",
    "JobsRetained": 9
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "SCS INDUSTRIES, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 10
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "SEA TO LAND LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 23
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "SECOND TO NONE, INCORPORATED",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 21
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "SERVANT SYSTEMS INCORPORATED",
    "BusinessType": "Corporation",
    "JobsRetained": 20
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "SERVO KINETICS, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 14
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "SEVA INC",
    "BusinessType": "Corporation",
    "JobsRetained": 43
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "SHAMROCK FLOORCOVERING SERVICES INC",
    "BusinessType": "Corporation",
    "JobsRetained": 11
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "SHELTER ASSOCIATION OF WASHTENAW COUNTY",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 48
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "SHOSHANA TECHNOLOGIES, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 14
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "SIMUQUEST, INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 11
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "SMART APARTMENT SOLUTIONS",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 29
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "SMITH FURNITURE CO. OF YPSI",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 26
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "SOCIETY FOR COLLEGE AND UNIVERSITY PLANNING",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 21
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "SOUTH STATE STREET ANN ARBOR RETAIL LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 28
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ST THOMAS THE APOSTLE ANN ARBOR",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 83
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ST. MARY STUDENT PARISH ANN ARBOR",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 26
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "STADIUM HARDWARE, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 19
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "STANDARD B & L,  LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 34
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "STATE AND LIBERTY CLOTHING COMPANY",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 15
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "STRUCTURAL DESIGN, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 9
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "SYNCHRONIS MEDICAL, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 16
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "TEMPLE BETH EMETH",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 70
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "THE 180 LSAT COMPANY",
    "BusinessType": "Corporation",
    "JobsRetained": 16
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "THE CENTER FOR MICHIGAN, INC.",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 15
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "THE CHOP HOUSE OF TOLEDO, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 38
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "THE DISCOVERY CENTER OF ANN ARBOR, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 28
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "THE FORWARD GROUP INC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 26
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "THE MODERN FIRM, LLC",
    "BusinessType": "Corporation",
    "JobsRetained": 10
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "THE PALIO OF ANN ARBOR, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 41
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "THE PRODUCE STATION, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 37
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "THE REALLY USEFUL INFORMATION COMPANY LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 36
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "THE UNDERSTANDING GROUP, LLC",
    "BusinessType": "Partnership",
    "JobsRetained": 14
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "THER A SUPPORT LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 26
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "TIOS ON LIBERTY LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 17
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "TOMTISHEN AOUN PLLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": ""
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "TOWER EDUCATION ASSOCIATION",
    "BusinessType": "Sole Proprietorship",
    "JobsRetained": 56
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "TRACKSIDE RESTAURANT CORPORATION",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 41
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "TREE TOWN PEDIATRIC DENTISTRY PLLC DBA A",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 10
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "TRIBBLE PAINTING COMPANY INC",
    "BusinessType": "Corporation",
    "JobsRetained": 18
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "TRR ENTERPRISES, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "TSRL INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 7
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "TURNER'S GREENSCAPE, LTD.",
    "BusinessType": "Corporation",
    "JobsRetained": 34
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "TWIN OAKS LANDSCAPE INC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 30
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "UBIQUITI INC",
    "BusinessType": "Corporation",
    "JobsRetained": 8
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ULTRASOUND MEDICAL DEVICES INC",
    "BusinessType": "Corporation",
    "JobsRetained": 7
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "UNITED WAY OF WASHTENAW COUNTY",
    "BusinessType": "Non-Profit Organization",
    "JobsRetained": 14
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "UNIVERSAL MANAGEMENT COMPANY LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 25
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "VANN PHOTO SERVICES, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 25
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "VAULT OF MIDNIGHT, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 25
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "VEDDER ELECTRIC, INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 0
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "VENDOR MANAGED TECHNOLOGIES, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 13
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "VIS-A-VIS SKIN SPA &AMP; BODYWORK, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 27
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "VISIUN INC",
    "BusinessType": "Corporation",
    "JobsRetained": 12
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "VLASIC DEVELOPMENT, L.L.C.",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 14
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "VOXEL51, INC",
    "BusinessType": "Corporation",
    "JobsRetained": 1
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "WESTARBOR ANIMAL HOSPITAL A2 PLLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 22
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "WILDERNESS CONSTRUCTION, INC.",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 14
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "WILSON WHITE COMPANY, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": ""
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "WOLVERINE SUPPLY, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 11
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "WORKIT HEALTH, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 23
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "WRE PLYMOUTH HOLDINGS LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 40
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "WSR CERTIFIED PUBLIC ACCOUNTANTS, P.C.",
    "BusinessType": "Corporation",
    "JobsRetained": 20
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "XITRON, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 15
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "Z SQUARED INC",
    "BusinessType": "Subchapter S Corporation",
    "JobsRetained": 40
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ZIEGLER GTP LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 20
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ZINGERMAN'S COFFEE COMPANY, LLC",
    "BusinessType": "Limited  Liability Company(LLC)",
    "JobsRetained": 41
  },
  {
    "LoanRange": "$150,000-350,000",
    "BusinessName": "ZINGERMAN'S TRAINING, INC.",
    "BusinessType": "Corporation",
    "JobsRetained": 16
  }
]
      }
    },
    methods: {
      customSort(items, index, isDesc) {
        items.sort((a, b) => {
          if (index == "LoanRange") {
            var a_ = 0
            var b_ = 0

            if(a.LoanRange == "$150,000-350,000"){
              a_ = 0
            }
            else if(a.LoanRange == "$350,000-1 million"){
              a_ = 1
            }
            else if(a.LoanRange == "$1-2 million"){
              a_ = 2
            }
            else if(a.LoanRange == "$2-5 million"){
              a_ = 3
            }
            else if(b.LoanRange == "$5-10 million"){
              a_ = 4
            }
            else{
              a_=-1
            }

            if(b.LoanRange === "$150,000-350,000"){
              b_ = 0
            }
            else if(b.LoanRange === "$350,000-1 million"){
              b_ = 1
            }
            else if(b.LoanRange === "$1-2 million"){
              b_ = 2
            }
            else if(b.LoanRange === "$2-5 million"){
              b_ = 3
            }
            else if(b.LoanRange === "$5-10 million"){
              b_ = 4
            }
            else{
              b_=-1
            }

            if (isDesc[0]) {
              return a_ < b_ ? -1: 1;
            } else {
              return a_ > b_ ? -1: 1;
            }
          } else {
            if (!isDesc[0]) {
              return a[index] < b[index] ? -1 : 1;
            } else {
              return b[index] < a[index] ? -1 : 1;
            }
          }
        });
          return items;
      }
    },
    created(){
    if(window.self !== window.top){
      this.home = true
    }
  }
  }
</script>